import React, { memo } from 'react';

import Fade from '@smart-tv/components/fade/fade';
import Typography from '@smart-tv/components/typography';
import RecordingIndicator from '@smart-tv/components/icons/recording-indicator';
import { LiveTvChannel } from '@smart-tv/typings/content';

import usePlayerRecording from './_hooks/use-player-recording';
import styles from './player-information.module.scss';

interface Props {
  channel?: LiveTvChannel;
}

const RecordingLabel = ({ channel }: Props) => {
  const { isRecording } = usePlayerRecording(channel);

  return (
    <Fade in={isRecording} unmountOnExit>
      <div className={styles['recording-label']}>
        <RecordingIndicator size={false} className={styles['recording-label__icon']} />
        <Typography variant="caption" className={styles['recording-label__text']}>
          Optager
        </Typography>
      </div>
    </Fade>
  );
};

export default memo(RecordingLabel);
